import {
  axiosDeleteRequest,
  axiosGetPaginatedRequest,
  axiosGetRequest,
  axiosPatchRequest,
  axiosPostRequest,
  axiosPutRequest,
  getCommunityRoute,
  getReferenceRoute,
} from '../../api';
import { CreateLikeDto, ReplyDto } from '../../common/dto';
import { ModeratorEditCommentDto, Reply } from './models';
import { ModerationReason } from './models/ModerationReason';

const getPostsRoute = () => `${getCommunityRoute()}/post`;
const getReplyToCommentRoute = () =>
  `${getCommunityRoute()}/room/{roomid}/post/{postid}/reply/{replyid}`;
const getCommentRoute = () =>
  `${getCommunityRoute()}/room/{roomId}/post/{postId}/reply`;
const getCommentUpdateRoute = () =>
  `${getCommunityRoute()}/post/{postId}/reply/{replyId}`;
const getLikeCommentRoute = () =>
  `${getCommunityRoute()}/room/{roomId}/post/{postId}/reply/{replyId}/like`;
const getReportCommentRoute = () =>
  `${getPostsRoute()}/{postId}/reply/{replyId}/report`;

const PAGE_SIZE = 5;

export const fetchCommentsPaginatedCall = (
  postId: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<Reply[]>(
    `${getPostsRoute()}/${postId}/replies/${numrecs || PAGE_SIZE}`,
    xMsContinuationToken
  );
};

export const fetchRepliesToCommentPaginatedCall = (
  postId: string,
  commentId: string,
  numrecs?: number,
  xMsContinuationToken?: string
) => {
  return axiosGetPaginatedRequest<Reply[]>(
    `${getPostsRoute()}/${postId}/reply/${commentId}/replies/${
      numrecs || PAGE_SIZE
    }`,
    xMsContinuationToken
  );
};

export const createCommentCall = (
  newComment: ReplyDto,
  roomId: string,
  postId: string
) => {
  return axiosPostRequest<ReplyDto, Reply>(
    getCommentRoute().replace('{roomId}', roomId).replace('{postId}', postId),
    newComment
  );
};

export const createReplyToCommentCall = (
  newReply: ReplyDto,
  roomId: string,
  postId: string,
  commentId: string
) => {
  return axiosPostRequest<ReplyDto, Reply>(
    getReplyToCommentRoute()
      .replace('{roomid}', roomId)
      .replace('{postid}', postId)
      .replace('{replyid}', commentId),
    newReply
  );
};

export const updateLikeCommentCall = (
  like: CreateLikeDto,
  roomId: string,
  postId: string,
  commentId: string
) => {
  return axiosPostRequest<CreateLikeDto, Reply>(
    getLikeCommentRoute()
      .replace('{roomId}', roomId)
      .replace('{postId}', postId)
      .replace('{replyId}', commentId),
    like
  );
};

export const deleteCommentCall = (postId: string, commentId: string) => {
  return axiosDeleteRequest<string, void>(
    getCommentUpdateRoute()
      .replace('{postId}', postId)
      .replace('{replyId}', commentId)
  );
};

export const updateCommentCall = (
  postId: string,
  commentId: string,
  updateComment: ReplyDto
) => {
  return axiosPutRequest<ReplyDto, Reply>(
    getCommentUpdateRoute()
      .replace('{postId}', postId)
      .replace('{replyId}', commentId),
    updateComment
  );
};

export const getReplyCall = (postId: string, replyId: string) => {
  return axiosGetRequest<Reply>(
    getCommentUpdateRoute()
      .replace('{postId}', postId)
      .replace('{replyId}', replyId)
  );
};

export const getCommentCall = (postId: string, commentId: string) => {
  return axiosGetRequest<Reply>(
    getCommentUpdateRoute()
      .replace('{postId}', postId)
      .replace('{replyId}', commentId)
  );
};

export const reportCommentCall = (postId: string, commentId: string) => {
  return axiosPatchRequest(
    getReportCommentRoute()
      .replace('{postId}', postId)
      .replace('{replyId}', commentId)
  );
};

export const moderatorDeleteCommentCall = (
  postId: string,
  commentId: string
) => {
  return axiosDeleteRequest<unknown, Reply>(
    `${getCommunityRoute()}/moderator/post/${postId}/reply/${commentId}`
  );
};

export const moderatorEditCommentCall = (
  postId: string,
  commentId: string,
  editCommentDto: ModeratorEditCommentDto
) => {
  return axiosPutRequest<unknown, Reply>(
    `${getCommunityRoute()}/moderator/post/${postId}/reply/${commentId}`,
    editCommentDto
  );
};

export const fetchModerationReasonsCall = () => {
  return axiosGetRequest<ModerationReason[]>(
    `${getReferenceRoute()}/moderationreasons`
  );
};
